<template>
  <div class="create-edit-dialog-form">
    <v-row justify="center">
      <v-dialog v-model="visible" persistent max-width="700px">
        <v-card>
          <v-form
            @submit.prevent="sendObjectToServer()"
            ref="createEditForm"
            v-model="form"
          >
            <v-card-title>
              <h3>{{ title }}</h3>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    v-for="(field, index) in Object.keys(fields).filter(f => !(fields[f].hide || false))"
                    :key="index"
                    cols="12"
                    sm="12"
                    :md="fields[field].md"
                  >
                    <v-text-field
                      v-if="fields[field].fieldType == 1 && !fields[field].hide"
                      :disabled="fields[field].disabled"
                      :required="fields[field].required || false"
                      :hint="fields[field].helper"
                      persistent-hint
                      :type="fields[field].input || 'text'"
                      hide-details="auto"
                      :prepend-icon="fields[field].prependIcon"
                      v-model="obj[field]"
                      :maxlength="fields[field].max"
                      
                      :rules="getFieldRules(field)"
                    >
                      <template #label>
                        {{ fields[field].label
                        }}<span v-if="fields[field].required" class="red--text"
                          ><strong> * </strong></span
                        >
                      </template>
                    </v-text-field>
                    <v-autocomplete
                      v-else-if="
                        fields[field].fieldType == 3 && !fields[field].hide
                      "
                      v-model="obj[field]"
                      :items="selectionItems[field]"
                      persistent-hint
                      :hint="fields[field].helper"
                      :label="fields[field].label"
                      :item-text="fields[field].itemText"
                      :item-value="fields[field].itemValue"
                      multiple
                      :rules="[rules.requiredList]"
                      chips
                    ></v-autocomplete>
                    <v-checkbox
                      v-else-if="
                        fields[field].fieldType == 4 && !fields[field].hide
                      "
                      :label="fields[field].label"
                      :hint="fields[field].helper"
                      persistent-hint
                      :type="fields[field].input || 'text'"
                      hide-details="auto"
                      :prepend-icon="fields[field].prependIcon"
                      v-model="obj[field]"
                      :rules="getFieldRules(field)"
                    />
                  </v-col>
                  <!-- <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Legal first name*"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Legal middle name"
                    hint="example of helper text only on focus"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Legal last name*"
                    hint="example of persistent helper text"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Email*" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Password*"
                    type="password"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    :items="['0-17', '18-29', '30-54', '54+']"
                    label="Age*"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    :items="[
                      'Skiing',
                      'Ice hockey',
                      'Soccer',
                      'Basketball',
                      'Hockey',
                      'Reading',
                      'Writing',
                      'Coding',
                      'Basejump',
                    ]"
                    label="Interests"

                    multiple
                  ></v-autocomplete>
                </v-col> -->
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="isLoading"
                color="blue darken-1"
                text
                @click="closeDialog()"
              >
                Close
              </v-btn>
              <v-btn
                :disabled="isLoading || !form || !allFieldsValid"
                color="blue darken-1"
                text
                type="submit"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn :color="snackbar.color" text @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import Vue from "vue";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";

export const CreateEditDialogTypes = Object.freeze({
  TEXTFIELD: 1,
  TEXTAREA: 2,
  SELECT: 3,
  CHECKBOX: 4,
});

export default {
  name: "CreateEditDialogForm",
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
    fields: {
      type: Object,
      default() {
        return {};
      },
    },
    endpoint: {
      type: String,
      default: "",
    },
    dataObject: {
      type: Object,
      default() {
        return {};
      },
    },
    editId: {
      type: Number,
      default: null,
    },
    successMessage: {
      type: String,
      default: "Successfully saved!",
    },
  },
  data() {
    return {
      obj: this.dataObject,
      initialObj: null,
      objectId: null,
      form: false,
      selectionItems: {},
      rules: {
        required: (v) => !!v || v === 0 || "Required",
        requiredList: (v) => v.length > 0 || "Required",
        numbersOnly: (v) => !v || !/[^\-0-9.]/.test(v) || "Invalid",
      },
      snackbar: {
        visible: false,
        text: "",
        color: "dark",
      },
    };
  },
  computed: {
    ...mapGetters(["accessToken", "isLoading"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
    allFieldsValid() {
      var fieldsValid = true;
      // console.log(this.fields);
      Object.keys(this.fields).forEach(f => {
        var fieldData = this.fields[f];
        if(fieldData.valid && !fieldData.hide){
          if(!fieldData.valid()) fieldsValid = false;
        }
      });
      return fieldsValid;
    }
  },
  methods: {
    ...mapActions(["setLoading"]),

    closeDialog() {
      // clear all values then close
      this.$emit("closeDialog");
      this.$refs.createEditForm.resetValidation();
      this.obj = null;
      this.objectId = null;
      this.initObjectFields();
      // this.obj = null;
    },

    getFieldRules(field) {
      var fieldRules = [];
      var fieldData = this.fields[field];
      var rules = fieldData.rules ?? [];
      fieldRules = rules.map((r) => this.rules[r]);

      if (fieldData.pattern)
        fieldRules.push((v) => !fieldData.pattern.test(v) || "Invalid");
      if (fieldData.required ?? false) fieldRules.push(this.rules["required"]);
      return fieldRules;
    },

    async sendObjectToServer() {
      // only send fields that are visible
      var url = this.objectId
        ? this.endpoint + this.objectId + "/"
        : this.endpoint;
      var response = await api.call(
        this.essentials,
        url,
        this.objectId ? api.Methods.PUT : api.Methods.POST,
        this.obj
      );
      if (response) {
        this.snackbar.color = "success";
        this.snackbar.text = this.successMessage;
        this.snackbar.visible = true;
        this.$emit("objectCreated", response);
        this.closeDialog();
      }
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.color = "red";
        this.snackbar.visible = true;
      }
    },

    async getEditObject() {
      var response = await api.call(
        this.essentials,
        this.endpoint + this.objectId + "/"
      );
      Object.keys(this.fields).map(f => {
        this.obj[f] = response[f];
      });
    },

    async getSelectionItems() {
      Object.keys(this.fields).map(async (f) => {
        // get items for multiselect fields based on endpoint
        var fieldData = this.fields[f];
        if (fieldData.fieldType == 3 && fieldData.endpoint) {
          this.selectionItems[f] = await api.call(
            this.essentials,
            fieldData.endpoint
          );
        }
      });
    },

    async initObjectFields() {
      this.obj = this.initialObj;
      Object.keys(this.fields).map(async (f) => {
        var fieldData = this.fields[f];
        Vue.set(this.obj, f, fieldData.value);
      });
    },
  },

  async mounted() {
    this.initObjectFields();
    // console.log("edit ID:", this.objectId);
  },

  async created() {
    this.initialObj = this.dataObject;
    this.getSelectionItems();
  },

  watch: {
    editId: {
      async handler() {
        this.objectId = this.editId;
        if (this.objectId) this.getEditObject();
      },
    },
    obj: {
      async handler() {
        this.$emit("updateObject", this.obj);
      },
      deep: true,
    },
  },
};
</script>